import React from "react"
import styled from "styled-components"

const Valid = styled.div`
  color: #52c41a;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6rem;
  height: 2rem;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 2px;
`

const Invalid = styled.div`
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6rem;
  height: 2rem;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`

const Published = ({ ...props }: React.ComponentProps<typeof Valid>) => {
  return <Valid {...props}>掲載中</Valid>
}

const NotPublished = ({ ...props }: React.ComponentProps<typeof Invalid>) => {
  return <Invalid {...props}>掲載停止</Invalid>
}

const NotApproved = ({ ...props }: React.ComponentProps<typeof Invalid>) => {
  return <Invalid {...props}>非承認</Invalid>
}

interface RecruitStatusProps {
  isPublished: boolean
  isApproved: boolean
}
export const RecruitStatus = ({
  isPublished,
  isApproved,
}: RecruitStatusProps &
  React.ComponentProps<typeof Valid | typeof Invalid>) => {
  if (!isApproved) return <NotApproved />
  if (!isPublished) return <NotPublished />
  return <Published />
}
